import {ChangeDetectionStrategy, Component, Inject, Input, OnChanges, OnInit, SimpleChanges} from "@angular/core";
import {Service} from "../../../models/service.model";
import {servicesExtraActions} from "../../constants/services-constants";
import * as _ from "lodash";

require('./service-action-menu.scss');
@Component({
  standalone: false,
  selector: 'app-service-action-menu',
  templateUrl: './service-action-menu.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServiceActionMenuComponent implements OnInit, OnChanges {
  @Input() service: Service;
  @Input() isDisableActionMenu: boolean;

  public actionsByStatusMap: any;
  public serviceExtraActionsByStatusMap: any;
  // public printerProvider: string;
  public actions: any;
  public extraActions: any;
  // public blockResetAction: boolean;
  public extraActionNames: any;

  constructor(@Inject('splitService') private splitService, @Inject('DeliveriesApiAction') private DeliveriesApiAction, @Inject('printerService') private printerService,
              @Inject('servicesService') private servicesService, @Inject('commonsDialogService') private commonsDialogService,
              @Inject('deliveriesDialogService') private deliveriesDialogService, @Inject('expensesDialogService') private expensesDialogService,
              @Inject('expensesService') private expensesService, @Inject('fulfillmentService') private fulfillmentService) {
  }

  ngOnInit() {
    this.extraActionNames = servicesExtraActions;
  }

  ngOnChanges(changes: SimpleChanges) {
    // if (changes.service && !changes.service.isFirstChange()) {
    //   this._initActions();s
    // }
  }

  onOpenActionMenu() {
    this._initActions();
  }

  private _initActions() {
    // this.actions = [];
    // this.extraActions = [];

    this.actions = [];
    this.extraActions = [];

    const actions = this.servicesService.getActionsByServices([this.service]);

    this.actions = _.filter(actions, (a) => {
      return !Object.values(this.extraActionNames).some((item: any) => item?.id === a.id)
    });
    this.extraActions = _.filter(actions, (a) => {
      return Object.values(this.extraActionNames).some((item: any) => item?.id === a.id)
    });

    // this.actions = this.actionsByStatusMap[this.service.serviceType][this.service.status];
    // this.extraActions = this.serviceExtraActionsByStatusMap[this.service.serviceType][this.service.status];

    // if (this.blockResetAction) {
    //   this.actions = this.actions.filter(a => a.id !== 'reset');
    // }

    // Print Label Test
    // const printLabelActionIndex = this.extraActions.findIndex((a: any) => a.id === 'PrintLabel')
    //
    // this.printerService.getPrintingConfig();
    // if (printLabelActionIndex > -1 && !this.printerService.getPrintingConfig().enabled) {
    //   this.extraActions.splice(printLabelActionIndex, 1);
    // }
    //
    //
    // if (this.printerProvider !== 'Ikea') {
    //   this.removeIkeaFromExtraActions();
    // }

    if (_.isEmpty(this.actions) && _.isEmpty(this.extraActions)) {
      return;
    }

  }

  onActionSelect(action, $event) {
    // onExtraActionSelect(action);
    this.DeliveriesApiAction[action]($event, [this.service.id], this.service.serviceType);
  }

  onExtraActionSelect(actionId, $event) {
    if (actionId === 'edit') {
      this.servicesService.onEditOne(this.service, true);
    } else if (actionId === 'Duplicate') {
      this.servicesService.onDuplicateOne(this.service);
    } else if (actionId === 'Print') {
      if (this.service.serviceType === 'Operation') {
        this.servicesService.onPrint([this.service.id]);
      } else {
        this.deliveriesDialogService.printDelivery()
          .then((purpose) => {
            this.servicesService.onPrint([this.service.id], purpose);
          })
      }
    } else if (actionId === 'PrintLabel') {
      this.printerService.printDelivery(this.service);
    } else if (actionId === 'PrintIkea') {
      this.commonsDialogService.printIkea([this.service]);
    } else if (actionId === 'CreateExpense') {
      this.expensesDialogService.createExpense($event, this.service.id)
        .then((expense) => {
          this.expensesService.createExpense(expense);
        })
    } else if (actionId === 'dispatchExternal') {
      this.deliveriesDialogService.dispatchStepExternal(this.service.fulfillmentId, this.service.fulfillmentStepId, $event)
        .then((selectedQuote) => {
          this.fulfillmentService.dispatchStep(this.service.fulfillmentId, this.service.fulfillmentStepId, selectedQuote);
        })
    }
  }

}
